export default {"src":"/_next/static/media/pythonIcon.66b9d512.svg","height":32,"width":32};